import { useContext, useState } from "react";
import api from "../../api";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";
import { AuthContext } from "../AuthContext";
import { set } from "lodash";

export interface ObservacaoContratoType {
    id: number
    observation: string;
    date: string;
    contratoId?: number | null;
}

export interface CreateObservacaoContratoType {
    observation: string;
    date?: string;
    contratoId?: number | null;
}

export interface EditObservacaoContratoType {
    id: number;
    observation: string;
    date?: string;
}

export default function useObservacaoContrato() {
    const showToast = useToast();
    const { setLoading } = useContext(LoadingContext);
    const { handleLogout, objUserTk } = useContext(AuthContext);
    const [listObservacaoContrato, setListObservacaoContrato] = useState<ObservacaoContratoType[]>([]);
    const [observacaoContratoPageCount, setObservacaoContratoPageCount] = useState<number>(0);
    const [initialListObservacaoContrato, setInitialListObservacaoContrato] = useState<ObservacaoContratoType[]>([]);
    const [observacaoContrato, setObservacaoContrato] = useState<ObservacaoContratoType>({
        id: 0,
        observation: "",
        date: "",
        contratoId: null,
    });

    function createObservacaoContrato(createObservacaoContratoType: CreateObservacaoContratoType): Promise<CreateObservacaoContratoType | null> {
        setLoading(true);
        return api
            .post(`/ObservacaoContrato/create`, createObservacaoContratoType)
            .then((response) => {
                const createdObservacaoContrato: CreateObservacaoContratoType = response.data;
                showToast("success", "Observação criada com sucesso.");
                setLoading(false);
                return createdObservacaoContrato;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao criar observação. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao criar observação:", error);
                return null;
            });
    }

    function getObservacaoContratoPaged(
        pageNumber: number,
        pageSize?: number,
        ContratoId?: number,
    ): Promise<ObservacaoContratoType[] | null> {
        setLoading(true);
        let url = `/ObservacaoContrato/getObservacaoContratoPaged?pageNumber=${pageNumber}&pageSize=${pageSize}`;

        if (ContratoId) {
            url += `&ContratoId=${ContratoId}`;
        }

        return api
            .get(url)
            .then((response) => {
                setListObservacaoContrato(response.data.result);
                setInitialListObservacaoContrato(response.data.result);
                setObservacaoContratoPageCount(response.data.pageCount);
                setLoading(false);
                return response.data.result;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao carregar observação. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao carregar observações:", error);
                return null;
            });
    }

    function updateObservacaoContrato(updateObservacaoContratoData: EditObservacaoContratoType): Promise<EditObservacaoContratoType | null> {
        setLoading(true);
        return api
            .put(`/ObservacaoContrato/${updateObservacaoContratoData.id}`, updateObservacaoContratoData)
            .then((response) => {
                showToast("success", "Observaçõa atualizada com sucesso.");
                setLoading(false);
                return response.data;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao atualizar observação. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao atualizar observação:", error);
                return null;
            });
    }

    function deleteObservacaoContrato(observacaoContratoId: number): Promise<ObservacaoContratoType | null> {
        setLoading(true);
        return api
            .delete(`/ObservacaoContrato/${observacaoContratoId}`)
            .then(() => {
                setObservacaoContrato({
                    id: 0,
                    observation: "",
                    date: "",
                    contratoId: null,
                });
                showToast("success", "Observação deletada com sucesso.");
                setLoading(false);
                return null;
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    handleLogout();
                    showToast(
                        "error",
                        "Sessão desconectada. Favor login novamente.",
                        error
                    );
                } else {
                    showToast(
                        "error",
                        "Erro ao deletar observação. Verifique novamente mais tarde.",
                        error
                    );
                }
                setLoading(false);
                console.error("Erro ao deletar oservação:", error);
                return null;
            });
    }

    return {
        createObservacaoContrato,
        getObservacaoContratoPaged,
        updateObservacaoContrato,
        deleteObservacaoContrato,
        setListObservacaoContrato,
        listObservacaoContrato,
        setObservacaoContratoPageCount,
        observacaoContratoPageCount,
        setInitialListObservacaoContrato,
        initialListObservacaoContrato,
        setObservacaoContrato,
        observacaoContrato,
    };
}
